import React from 'react';
import "./FilterSearchInput.scss"


const FilterSearchInput = (props) => {

    const {apiFilters, chipData, setChipData} = props;

    const onFilter = (value) => {
        if (chipData.find(chip => chip.label === value)) {
            let filterChipData = chipData.filter(chip => chip.label !== value);
            setChipData(filterChipData);
        } else {
            const key = chipData.length === 0 ? 0 : chipData[chipData.length -1].key + 1;
            setChipData([...chipData, { key: key, label: value }]);
        }
    }

    return (
        <div className={"filter-search-input-container-parent"}>
            <span className={"filter-search-input-title-text"}>Filters</span>
            {apiFilters.length > 0 ?
                apiFilters.map((apiFilter) => {
                    return (
                        <div key={crypto.randomUUID()}>
                            <span className={"filter-search-input-filter-title-text"}>{apiFilter.name}</span>
                            <ul className={"filter-search-input-filter-separator"}>
                                {apiFilter.filters.length > 0 ?
                                    apiFilter.filters.map(((filter) => {
                                    return (
                                        <li key={crypto.randomUUID()} onClick={() => onFilter(filter)} className={"filter-search-input-filter-subtitle-text"}>{filter}</li>
                                    )})) : null}
                            </ul>
                        </div>
                )})
                : null}
        </div>
    );
};

export default FilterSearchInput;
